import { combineReducers } from "redux";
import mainALLReducer from "./dashboardReducer";
import isResultReducer from "./isResultReducer";
//IndexImportHygen
const allDashboardReducer = combineReducers({
    isResultReducer,
    mainALLReducer
    //IndexUsingHygen
})

export default allDashboardReducer;